import React from "react";

export function Tradele() {
  return (
    <span className="font-bold">
      <span className="text-oec-orange">TRAD</span>LE
    </span>
  );
}
